import { createContext } from "react";

interface EstimationContextType {
  showNewEstimationModal: boolean;
  toggleShowNewEstimationModal: () => void;
}

export const CreateEstimationContext = createContext<EstimationContextType | undefined>(undefined);
